<!--
 * @Author: DY
 * @Date: 2024-12-03 14:02:33
 * @LastEditTime: 2024-12-12 10:36:13
 * @Description: 调拨出库确认列表
 * @FilePath: \ShiMo_Mobile\src\views\storage\allocationOutboundConfirm\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="allocationOutboundConfirm commonListStyles">
            <HeaderNav
                header-title="调拨出库确认"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">调拨单号：{{ item.TransferNo }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.Status | allocationStatus }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.MaterialCodes }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.MaterialShortNames }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>调拨数量：{{ item.VolumeTransfer }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3@2x.png" alt="">
                                            <span>调出仓库：{{ item.OutStockName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_3@2x.png" alt="">
                                            <span>调入仓库：{{ item.InStockName }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>调拨确认时间：{{ item.OutStockConfirmTime }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.Status === 1">
                                            <button @click="editAllocation(item)">
                                                编辑
                                            </button>
                                        </template>
                                        <template v-if="item.Status === 3">
                                            <button @click="editAllocation(item)">
                                                出库确认
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button @click="editAllocation(item)">
                                                查看
                                            </button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'allocation-outbound-confirm',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'allocation-outbound-confirm');
        }
        next();
    },
    data() {
        return {
            requestUrl: '/procurement/stock_transfer/page_list/bpbj/out',
            initIndex: 1,
            pageIndex: 1,
            indexKey: 'PageIndex',
            sizeKey: 'PageSize',
        };
    },
    filters: {
        allocationStatus(val) {
            const status = ['待提交', '确认中', '确认中', '待出库', '已出库', '已作废'];
            return status[val];
        },
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        loadRequestData() {
            return {
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                SearchKey: this.keyVal,
            };
        },

        editAllocation(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'allocationOutboundConfirmForm', params: { data: item } });
        },
    },
};
</script>
<style lang="stylus">
.allocationOutboundConfirm
    section
        .van-pull-refresh
            height: calc(100% - 44rpx) !important
</style>
